// @flow

import type { IncomingPayment } from '@tectonics/prs/incoming-payment';

export async function getPaymentFromApi(hash: string, localTenancy?: string): Promise<IncomingPayment> {
  const headers = new Headers();

  if (localTenancy) {
    headers.append('X-Custom-EBX-Platform', localTenancy);
  }

  const options = { headers };
  const response = await fetch(`${ENV_CONSTANTS.ANDES_BASE_URL}/payments/${hash}`, options);
  const { payment, status, code, error } = await response.json();

  if (status !== 'SUCCESS') {
    throw new Error(`getPaymentFromApi - ${code} ${error}`);
  }

  return payment;
}
